(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["np-shipping-break"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-shipping-break')) {
    customElements.define('np-shipping-break', class extends HTMLElement {
      connectedCallback() {
        this.checkExpiry = () => {
          window.clearTimeout(this.expiryTimer);
          const remaining = Date.parse(this.dataset.resumeAt) - Date.now();
          if (!Number.isFinite(remaining)) return;
          if (remaining <= 0) {
            this.remove();
            return;
          }
          this.expiryTimer = window.setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
        };
        document.addEventListener('visibilitychange', this.checkExpiry);
        window.addEventListener('pageshow', this.checkExpiry);
        this.checkExpiry();
      }

      disconnectedCallback() {
        window.clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.checkExpiry);
        window.removeEventListener('pageshow', this.checkExpiry);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
